import { render, staticRenderFns } from "./dialogManageCompany.vue?vue&type=template&id=2786939a&scoped=true"
import script from "./dialogManageCompany.vue?vue&type=script&lang=js"
export * from "./dialogManageCompany.vue?vue&type=script&lang=js"
import style0 from "./dialogManageCompany.vue?vue&type=style&index=0&id=2786939a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786939a",
  null
  
)

export default component.exports